/* eslint-disable no-unreachable */
import React from "react";
import { Route } from "react-router";
import { Redirect } from "react-router-dom";
import {
    getPrePozadavkyMenuItems,
    getPozadavkyMenuItems,
    getUkolyMenuItems,
    getAdminMenuItems,
    getSchvaleniMenuItems,
} from "./const/MenuItems";
const ROOT_PATH = "/qsign";
export function documentRoot(isAdmin: boolean) {
  const menuItems = [
    ...getPrePozadavkyMenuItems(),
    ...getPozadavkyMenuItems(),
    ...getUkolyMenuItems(),
    ...getAdminMenuItems(isAdmin),
    ...getSchvaleniMenuItems(),
  ];
  const documentRootRoutes = [
    <Route key={menuItems[0].key} path={menuItems[0].path} component={menuItems[0].component} />,
  ];
  menuItems.map((menuItem) =>
    documentRootRoutes.push(<Route key={menuItem.key} path={menuItem.path} component={menuItem.component} />)
  );
  documentRootRoutes.push(<Redirect key={0} from={ROOT_PATH} to={menuItems[0].path} />);
  return {
    documentRootRoutes: documentRootRoutes,
  };
}
